var React = require('react');

function Lt (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#C1272D","width":"5","height":"3","key":0}),React.createElement("rect",{"fill":"#006A44","width":"5","height":"2","key":1}),React.createElement("rect",{"fill":"#FDB913","width":"5","height":"1","key":2})]);
}

Lt.defaultProps = {"viewBox":"0 0 5 3"};

module.exports = Lt;

Lt.default = Lt;
